import { z } from 'zod';
import { UNKNOWN_STATUS } from '@/components/semantic-badge';
import { zodRemoveNullable } from '@/lib/zod-helper';
import { labReportDetailDtoSchema } from '~/generated/cdr/zod-schema';

const resultStatusSchema = z
  .enum(['H', 'L', 'AA', 'A', 'N', UNKNOWN_STATUS])
  .catch(UNKNOWN_STATUS);

export type LabResultStatus = z.infer<typeof resultStatusSchema>;

export const labReportDetailSchema = zodRemoveNullable(
  labReportDetailDtoSchema,
  {
    excludeMask: {
      valueString: true,
      note: true,
      resultStatusI18n: true,
      resultStatus: true,
      normalRangeLow: true,
      normalRangeHigh: true,
      normalText: true,
      valueQuantity: true,
    },
  },
).extend({
  resultStatus: resultStatusSchema,
});

export type LabReportDetail = z.infer<typeof labReportDetailSchema>;
